import { TriggerableLifetimeManager } from './disposable';

/**
 * The LifetimeData class.
 */
export class LifetimeData {
    /**
     * Lifetime manager of the application.
     */
    public manager: TriggerableLifetimeManager = new TriggerableLifetimeManager();
}
